import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { FormSelectOption } from '../../../entities/form-select-option.entity';
import { FormSelectStyle } from '../../../entities/form-select-style.entity';
import { ShBaseFormComponent } from '../../_core/base-form/base-form.component';
import { AsyncPipe, NgClass } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { ShFormSelectBaseComponent } from '../base/form-select-base.component';
import { ShFormGroupComponent } from '../../_core/form-group/form-group.component';

@Component({
    selector: 'sh-form-select',
    templateUrl: './form-select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [ShFormGroupComponent, ShFormSelectBaseComponent, ReactiveFormsModule, NgClass, AsyncPipe]
})
export class ShFormSelectComponent extends ShBaseFormComponent {
    @Input() options: FormSelectOption[] | null;
    @Input() style?: FormSelectStyle = FormSelectStyle.Default;
    @Input() showEmptyOption: boolean = true;
    @Input() emptyOptionLabel: string = '';
}
